import React, { Component } from 'react';
import { Card } from 'antd';
import { observer, inject } from 'mobx-react';

import { isEmpty, isBoolean } from 'lodash';

import StepCustomIcon from './StepCustomIcon';

import './LeadsStatusSummary.css';

@inject('translationsStore', 'filterStore', 'leadsStore')
@observer
class LeadsStatusSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: {}
    };
  }

  componentDidMount = () => {
    const { filterStore } = this.props;
    filterStore.addToMonitoring(`status.notified`);
    filterStore.addToMonitoring(`status.sent`);
    filterStore.addToMonitoring(`status.action`);
    filterStore.addToMonitoring(`status.booked`);
    filterStore.addToMonitoring(`status.discarded`);
    filterStore.addToMonitoring(`status.suspended`);
  };

  componentWillUnmount = () => {
    const { filterStore } = this.props;
    filterStore.removeFromMonitoring(`status.notified`);
    filterStore.removeFromMonitoring(`status.sent`);
    filterStore.removeFromMonitoring(`status.action`);
    filterStore.removeFromMonitoring(`status.booked`);
    filterStore.removeFromMonitoring(`status.discarded`);
    filterStore.removeFromMonitoring(`status.suspended`);
  };

  static getDerivedStateFromProps(props, state) {
    let newState = Object.assign({}, state);

    if (!isEmpty(props.data)) {
      newState = Object.assign(newState, { data: props.data });
    }
    if (isBoolean(props.loading)) {
      newState = Object.assign(newState, { loading: props.loading });
    }
    return newState;
  }

  toggleFilter = name => () => {
    const { filterStore, leadsStore } = this.props;
    ['notified', 'sent', 'action', 'booked', 'discarded'].filter(filter => filter !== name).forEach(filter => filterStore.remove(`status.${filter}`));
    filterStore.add(`status.${name}`, leadsStore[`${name}FilterFn`], true);
    setTimeout(() => {
      //setTimeout in order to show the toggle before rendering
      filterStore.apply();
    }, 10);
  };

  isFilterSelected = name => !!this.props.filterStore.filters[`status.${name}`];

  isFilterDisabled = (filterType, filter) => {
    if (this.props.leadsStore.filterLength(filterType, filter) === 0) {
      return true;
    }
    return false;
  };

  render() {
    const { translationsStore, leadsStore } = this.props;
    return (
      <Card bordered={false} style={{ ...this.props.style }} className="LeadsStatusSummary">
        <div style={{ display: 'flex' }} className="stepIcons">
          <div className="horizontalRule" />
          <StepCustomIcon
            selected={this.isFilterSelected('notified')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'notified')) return false;
              this.toggleFilter('notified').apply();
            }}
            type="notified"
            data={leadsStore.filterLength('status', 'notified')}
            disabled={this.isFilterDisabled('status', 'notified')}
            title={translationsStore.translate('lead.status.notified')}
          />

          <StepCustomIcon
            selected={this.isFilterSelected('sent')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'sent')) return false;
              this.toggleFilter('sent').apply();
            }}
            type="sent"
            data={leadsStore.filterLength('status', 'sent')}
            disabled={this.isFilterDisabled('status', 'sent')}
            title={translationsStore.translate('lead.status.sent')}
          />
          <StepCustomIcon
            selected={this.isFilterSelected('action')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'action')) return false;
              this.toggleFilter('action').apply();
            }}
            type="action"
            data={leadsStore.filterLength('status', 'action')}
            disabled={this.isFilterDisabled('status', 'action')}
            title={translationsStore.translate('lead.status.action')}
          />
          <StepCustomIcon
            selected={this.isFilterSelected('booked')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'booked')) return false;
              this.toggleFilter('booked').apply();
            }}
            type="booked"
            data={leadsStore.filterLength('status', 'booked')}
            disabled={this.isFilterDisabled('status', 'booked')}
            title={translationsStore.translate('lead.status.booked')}
          />
          <StepCustomIcon
            selected={this.isFilterSelected('discarded')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'discarded')) return false;
              this.toggleFilter('discarded').apply();
            }}
            type="discarded"
            data={leadsStore.filterLength('status', 'discarded')}
            disabled={this.isFilterDisabled('status', 'discarded')}
            title={translationsStore.translate('lead.status.discarded')}
          />
          <StepCustomIcon
            selected={this.isFilterSelected('suspended')}
            onClick={() => {
              if (this.isFilterDisabled('status', 'suspended')) return false;
              this.toggleFilter('suspended').apply();
            }}
            type="suspended"
            data={leadsStore.filterLength('status', 'suspended')}
            disabled={this.isFilterDisabled('status', 'suspended')}
            title={translationsStore.translate('lead.status.suspended')}
          />
        </div>
      </Card>
    );
  }
}

export default LeadsStatusSummary;
